module.exports = __webpack_public_path__ + "img/sk_icons.c4702e9.svg";